import GameConfig from "../core/data/GameConfig";
import GameScene from "../scenes/GameScene";
import { HiddenObjectData } from "./HiddenObjectData";

export class HiddenObject {
	static ON_PRESSED = "ON_PRESSED";

	id: number;
	layer: number;
	image: Phaser.GameObjects.Image;
	events: Phaser.Events.EventEmitter;
	scene: GameScene;

	protected found = false;
	protected enabled = false;
	protected _availableDuration: number;

	private _timeBetweenHints: number;
	protected _timeUntilHint: number;

	constructor(objectData: HiddenObjectData, scene: GameScene, id: number) {
		this.events = new Phaser.Events.EventEmitter();
		this.scene = scene;
		this.found = false;
		this.enabled = false;

		this.id = id;

		const layers = scene.hiddenObjGame.bgLayers;
		const max = layers.length - 1;
		this.layer = this.isValid(objectData.layer) ? Phaser.Math.Clamp(objectData.layer, 0, max) : max;

		const img = objectData.image;
		this.image = scene.add.image(objectData.x, objectData.y, img);
		// this.image.setOrigin(0, 1);
		this.image.angle = objectData.rotation;

		if (objectData.flipX == true) this.image.flipX = objectData.flipX;
		if (objectData.flipY == true) this.image.flipY = objectData.flipY;

		this.image.setDisplaySize(objectData.width, objectData.height);

		this._timeBetweenHints = GameConfig.get<number>("hintTimer");
		this._timeUntilHint = this._timeBetweenHints;

		//this.image.setInteractive();
		this.image.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
		scene.hiddenObjGame.addHiddenObject(this.image, this.layer);
	}

	protected isValid(value: CallbackContext): boolean {
		return value != null && value != undefined;
	}

	update(delta: number): void {
		if (!this.found && this.enabled) {
			this._availableDuration += delta;

			this._timeUntilHint -= delta;
			if (this._timeUntilHint <= 0) {
				this.createSparkles();
				this._timeUntilHint = this._timeBetweenHints;
			}
		}
	}

	onPointerDown(): void {
		this.found = true;
		this.events.emit(HiddenObject.ON_PRESSED, this);
	}

	isFound(): boolean {
		return this.found;
	}

	disable(): void {
		this.image.disableInteractive();
		this.enabled = false;
	}

	enable(): void {
		this.image.setInteractive();
		this._availableDuration = 0;
		this._timeUntilHint = this._timeBetweenHints;
		this.enabled = true;
	}

	destroy(): void {
		this.image.removeAllListeners(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
		this.image.destroy();
	}

	createSparkles(): void {
		if (!this.found) {
			const particleContainer = this.scene.add.container();
			this.scene.add.existing(particleContainer);

			let sparkleAdjustmentX = 0;
			let sparkleAdjustmentY = 0;
			const screenRatio = this.scene.viewport.width / this.scene.viewport.height;
			const goalRatio = 16 / 9;
			const ratioDif = screenRatio - goalRatio;
			if (screenRatio > goalRatio) sparkleAdjustmentX = 540 * ratioDif;
			else {
				// get change in x and y dependant on distance from the center of the screen
				// const screenCenterX = this.scene.viewport.width / 2;
				const screenCenterY = this.scene.viewport.height / 2;
				// const xToCenter = screenCenterX - this.image.x;
				const xToLeft = -this.image.x;
				const yToCenter = screenCenterY - this.image.y;
				// sparkleAdjustmentX = xToCenter * -ratioDif;
				sparkleAdjustmentX = xToLeft * ratioDif * -0.5;
				sparkleAdjustmentY = yToCenter * -ratioDif;
			}

			particleContainer.setPosition(this.image.x + sparkleAdjustmentX, this.image.y + sparkleAdjustmentY);

			const particles: Phaser.GameObjects.Image[] = [];

			for (let i = 0; i < 18; i++) {
				let radius = this.image.displayWidth / 2;
				if (this.image.displayWidth < this.image.displayHeight) radius = this.image.displayHeight / 2;

				const circle = new Phaser.Geom.Circle(0, 0, radius);
				const pos = circle.getRandomPoint();
				const particleTexture = "sparkle" + (1 + (i % 2));

				const particle = this.scene.add.image(pos.x, pos.y, particleTexture);
				particle.scale = 0;
				particles.push(particle);
				particleContainer.add(particle);

				this.scene.tweens.add({
					targets: particle,
					scale: { from: 0, to: 0.8 },
					alpha: { from: 0, to: 0.8 },
					duration: 400,
					yoyo: true,
					ease: Phaser.Math.Easing.Quadratic.InOut,
					delay: Phaser.Math.RND.between(0, 700),
				});
			}
		}
	}

	public getPointTotal(): number {
		return 100 - Math.min(10, Math.floor(this._availableDuration)) * 5;
	}
}
